var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-input',{attrs:{"value":_vm.value,"type":"text","placeholder":"value","state":_vm.showErrors && !_vm.value ? false : null,"required":""},on:{"change":function (v) { return _vm.$emit('change', {value: v}); }}})}
var staticRenderFns = []

export { render, staticRenderFns }